if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');         
      if(!this.form) return;
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    // Get cart element lazily to handle timing issues
    getCart() {
      const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      // Check if cart element has the required methods (custom element is upgraded)
      if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
        return cartEl;
      }
      return null;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      // Get cart lazily - may not be ready in constructor
      const cart = this.getCart();
      
      if (cart) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      } else {
        // Fallback: request default sections
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      fetch(`${window.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }
          
          // Get cart again (might be upgraded now)
          const cartNow = this.getCart();
          
          if (!cartNow) {
            // No cart drawer, redirect to cart page
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { cartNow.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            cartNow.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          const cartFinal = this.getCart();
          if (cartFinal && cartFinal.classList.contains('is-empty')) cartFinal.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          const spinner = this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');          
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

